import { CaosConfigurationTemplate } from "@/model/data/caosConfiguration/CaosConfigurationTemplate";
import { ApiGenericResponse } from "../ApiGenericResponse";
import { API_PREFIX, API_VERSION, Command, HttpVerbType } from "../Command";

const ENDPOINT = "/caosconfiguration/template/add";

export class AddTemplateCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "post";
    payload: AddTemplateReqData;

    constructor(payload: AddTemplateReqData) {
        super();
        this.payload = payload;
    }

    public async execute(): Promise<ApiGenericResponse> {
        let res = await this.executeCommand(this.payload);
        return new ApiGenericResponse(res);
    }
}

export class AddTemplateReqData {
    template: CaosConfigurationTemplate;

    constructor(template: CaosConfigurationTemplate) {
        this.template = template;
    }
}
